module.exports = __webpack_public_path__ + "static/media/pilotly-logo-symbol.942414fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pilotly-logo-symbol.svg
// module id = 614
// module chunks = 0